import { EpimsBaseEntityDto } from './epim-base.dto';
export class CabinetShelfRefDto extends EpimsBaseEntityDto {
    CabinetShelfRefNo: string;
    FileLocationId: string;
}